<section class="tienda" [ngStyle]="{ 'margin-top': isMovil ? '0px' : '20px' }">
    <div class="tienda-titulo">
        <img [src]="isMovil ? currentBanner.imagenMovil : currentBanner.imagenPC" alt="{{currentBanner.titulo}}" (error) ="changeSource($event)" loading="lazy">
    </div>

    <section class="tienda-content">
        <div class="tienda-content-filtros">
            <section class="filtros-categorias">
                <button class="acceso-form-content-button fondo-purple" (click)="clearFilters()">Limpiar filtros</button>
            </section>
            <section class="filtros-categorias">
                <h3 (click)=" fnMostrarFiltros( 1, $event ) ">
                    Categorías
                    <span *ngIf=" !showFiltoCategoria ">
						<i class="fas fa-caret-down"></i>
					</span>
                    <span *ngIf=" showFiltoCategoria ">
						<i class="fas fa-caret-up"></i>
					</span>
                </h3>
                <section class="filtro-content-categorias" [hidden]=" !showFiltoCategoria ">
                    <div class="filtros-categorias-item" *ngFor="let newCategoria of listaCategorias">
                        <p (click)="fnSeleccionCategoria( newCategoria )" *ngIf="newCategoria.productos > 0 || esTiendaHome">
                            <span *ngIf=" newCategoria.seleccionado "><i class="far fa-check-square"></i></span>
                            <span *ngIf=" !newCategoria.seleccionado "><i class="far fa-square"></i></span> {{ newCategoria.nombre }} ({{ newCategoria.productos }})
                        </p>
                        <section *ngIf=" newCategoria.seleccionado ">
                            <div class="filtros-subcategorias-item" *ngFor="let newSubcategoria of newCategoria.subcategorias | sort:'nombre'" [ngStyle]="{'display': ( newSubcategoria.productos > 0 || esTiendaHome ) ? 'block' : 'none' }">
                                <p (click)="fnSeleccionCategoria( newSubcategoria )">
                                    <span *ngIf=" newSubcategoria.seleccionado "><i class="far fa-check-square"></i></span>
                                    <span *ngIf=" !newSubcategoria.seleccionado "><i class="far fa-square"></i></span> {{ newSubcategoria.nombre }} ({{ newSubcategoria.productos }})
                                </p>
                                <section *ngIf=" newSubcategoria.seleccionado ">
                                    <div class="filtros-subcategorias-item" *ngFor="let newSubSubcategoria of newSubcategoria.subcategorias | sort:'nombre'">
                                        <p (click)="fnSeleccionCategoria( newSubSubcategoria )">
                                            <span *ngIf=" newSubSubcategoria.seleccionado "><i class="far fa-check-square"></i></span>
                                            <span *ngIf=" !newSubSubcategoria.seleccionado "><i class="far fa-square"></i></span> {{ newSubSubcategoria.nombre }} ({{ newSubSubcategoria.productos }})
                                        </p>
                                    </div>
                                </section>
                            </div>
                        </section>
                    </div>
                </section>
            </section>
            <section class="filtros-precios">
                <h3 (click)=" fnMostrarFiltros( 2, $event ) ">
                    Rango de precios
                    <span *ngIf=" !showFiltoPrecio ">
						<i class="fas fa-caret-down"></i>
					</span>
                    <span *ngIf=" showFiltoPrecio ">
						<i class="fas fa-caret-up"></i>
					</span>
                </h3>
                <section class="filtro-content-precios" [hidden]=" !showFiltoPrecio ">
                    <div class="filtros-categorias-item" *ngFor="let newPrecio of listaRangos">
                        <p (click)="fnSeleccionPrecio( newPrecio )">
                            <span *ngIf=" newPrecio.seleccionado "><i class="far fa-check-square"></i></span>
                            <span *ngIf=" !newPrecio.seleccionado "><i class="far fa-square"></i></span> ${{ newPrecio.inicio }} - ${{ newPrecio.fin }}
                        </p>
                    </div>
                </section>
            </section>
            <section class="filtros-marcas" *ngIf="esTiendaHome">
                <h3 (click)=" fnMostrarFiltros( 3, $event ) ">
                    Marcas
                    <span *ngIf=" !showFiltoMarca ">
						<i class="fas fa-caret-down"></i>
					</span>
                    <span *ngIf=" showFiltoMarca ">
						<i class="fas fa-caret-up"></i>
					</span>
                </h3>
                <section class="filtro-content-marcas" [hidden]=" !showFiltoMarca ">
                    <div>
                        <input type="text" placeholder="Buscar marca..." [(ngModel)]="txtMarcas">
                    </div>
                    <section>
                        <div class="filtros-marcas-item" *ngFor="let newMarca of listaMarcas | sort:'nombre' | filter:'nombre':txtMarcas">
                            <p (click)="fnSeleccionMarca( newMarca )">
                                <span *ngIf=" newMarca.seleccionado "><i class="far fa-check-square"></i></span>
                                <span *ngIf=" !newMarca.seleccionado "><i class="far fa-square"></i></span> {{ newMarca.nombre }} ({{ newMarca.productos }})
                            </p>
                        </div>
                    </section>
                </section>
            </section>
            <section class="filtros-categorias">
                <button class="acceso-form-content-button fondo-purple" (click)="clearFilters()">Limpiar filtros</button>
            </section>
        </div>
        <div class="tienda-content-productos">
            <section class="tienda-content-productos-paginador">
                <div>
                    <div>
                        <p>Mostrando {{ paginacion.inicio }} - {{ paginacion.fin }} de {{ totalProductos }} resultados</p>
                    </div>
                    <div>
                        <app-paginador (eventSuccess)="fnPaginarProductos( $event )" (eventFail)="fnErrorPaginador( $event )" [totalPaginas]="paginacion.totalPaginas" [currentPage]="paginacion.currentPage"></app-paginador>
                    </div>
                    <div>
                        <div class="tienda-content-filtros-movil">
                            <button class="fondo-purple" (click)=" fnMostrarFiltroMovil() "> Filtros </button>
                        </div>
                        <div class="selec-orden">
                            <app-select (newModelo)="fnUpdateOrden( $event )" [titulo]="tituloOrden" [currentModelo]="paginacion.orden" [listaElementos]="listaOrdenamiento"></app-select>
                        </div>
                    </div>
                </div>
            </section>
            <section class="tienda-content-productos-lista" *ngIf=" listaProductos.length > 0 ">
                <div *ngFor="let newProducto of listaProductos">
                    <app-item-producto [newProducto]="newProducto"></app-item-producto>
                </div>
            </section>
            <section class="tienda-content-productos-empty" *ngIf=" listaProductos.length === 0 && !isLoading && !initPage ">
                <!-- <h1>Upps... sin productos que mostrar</h1> -->
                <div>
                    <h1> OOPS! </h1>
                </div>
                <div>
                    <p>No se ha encontrado ningún producto</p>
                    <p class="color-gray">¿Qué hago?</p>
                    <p class="color-gray">Compruebe los términos introducidos.</p>
                    <p class="color-gray">Intenta utilizar una sola palabra.</p>
                    <p class="color-gray">Utilice términos genéricos en la búsqueda.</p>
                    <p class="color-gray">Busque utilizar sinónimos al término deseado.</p>
                </div>
            </section>
            <section class="tienda-content-productos-paginador">
                <div>
                    <div>
                        <p>Mostrando {{ paginacion.inicio }} - {{ paginacion.fin }} de {{ totalProductos }} resultados</p>
                    </div>
                    <div>
                        <app-paginador (eventSuccess)="fnPaginarProductos( $event )" (eventFail)="fnErrorPaginador( $event )" [totalPaginas]="paginacion.totalPaginas" [currentPage]="paginacion.currentPage"></app-paginador>
                    </div>
                </div>
            </section>
        </div>
    </section>
</section>



<section class="modal-filtros" [hidden]=" !mostrarFiltrosMovil ">
    <div>
        <section class="modal-filtros-header">
            <h3>
                Filtros de busqueda
                <span (click)=" fnMostrarFiltroMovil() ">
					<i class="fas fa-times"></i>
				</span>
            </h3>
        </section>
        <section class="modal-filtros-body">
            <div>
                <h3> <b>Categorías</b> </h3>
                <section class="filtro-content-categorias">
                    <div class="filtros-categorias-item" *ngFor="let newCategoria of listaCategorias">
                        <p (click)="fnSeleccionCategoriaMovil( newCategoria )" *ngIf="newCategoria.productos > 0 || esTiendaHome">
                            <span *ngIf=" newCategoria.seleccionado "><i class="far fa-check-square"></i></span>
                            <span *ngIf=" !newCategoria.seleccionado "><i class="far fa-square"></i></span> {{ newCategoria.nombre }} ({{ newCategoria.productos }})
                        </p>
                        <section *ngIf=" newCategoria.seleccionado ">
                            <div class="filtros-subcategorias-item" *ngFor="let newSubcategoria of newCategoria.subcategorias | sort:'nombre'"  [ngStyle]="{'display': ( newSubcategoria.productos > 0 || esTiendaHome ) ? 'block' : 'none' }">
                                <p (click)="fnSeleccionCategoriaMovil( newSubcategoria )">
                                    <span *ngIf=" newSubcategoria.seleccionado "><i class="far fa-check-square"></i></span>
                                    <span *ngIf=" !newSubcategoria.seleccionado "><i class="far fa-square"></i></span> {{ newSubcategoria.nombre }} ({{ newSubcategoria.productos }})
                                </p>
                                <section *ngIf=" newSubcategoria.seleccionado ">
                                    <div class="filtros-subcategorias-item" *ngFor="let newSubSubcategoria of newSubcategoria.subcategorias | sort:'nombre'">
                                        <p (click)="fnSeleccionCategoriaMovil( newSubSubcategoria )">
                                            <span *ngIf=" newSubSubcategoria.seleccionado "><i class="far fa-check-square"></i></span>
                                            <span *ngIf=" !newSubSubcategoria.seleccionado "><i class="far fa-square"></i></span> {{ newSubSubcategoria.nombre }} ({{ newSubSubcategoria.productos }})
                                        </p>
                                    </div>
                                </section>
                            </div>
                        </section>
                    </div>
                </section>
                <h3> <b>Rango de precios</b> </h3>
                <section class="filtro-content-precios">
                    <div class="filtros-categorias-item" *ngFor="let newPrecio of listaRangos">
                        <p (click)="fnSeleccionPrecioMovil( newPrecio )">
                            <span *ngIf=" newPrecio.seleccionado "><i class="far fa-check-square"></i></span>
                            <span *ngIf=" !newPrecio.seleccionado "><i class="far fa-square"></i></span> ${{ newPrecio.inicio }} - ${{ newPrecio.fin }}
                        </p>
                    </div>
                </section>
                <h3 *ngIf="esTiendaHome"> <b>Marcas</b> </h3>
                <section class="filtro-content-marcas" *ngIf="esTiendaHome">
                    <div>
                        <input type="text" placeholder="Buscar marca..." [(ngModel)]="txtMarcas">
                    </div>
                    <section>
                        <div class="filtros-marcas-item" *ngFor="let newMarca of listaMarcas | sort:'nombre' | filter:'nombre':txtMarcas">
                            <p (click)="fnSeleccionMarcaMovil( newMarca )">
                                <span *ngIf=" newMarca.seleccionado "><i class="far fa-check-square"></i></span>
                                <span *ngIf=" !newMarca.seleccionado "><i class="far fa-square"></i></span> {{ newMarca.nombre }} ({{ newMarca.productos }})
                            </p>
                        </div>
                    </section>
                </section>
            </div>
        </section>
        <section class="modal-filtros-footer">
            <button class="fondo-blue" (click)=" fnAplicarFiltros() ">
				Aplicar filtros
			</button>
            <button class="fondo-purple" (click)=" clearFilters() ">
				Limpiar filtros
			</button>
        </section>
    </div>
</section>